export default __webpack_public_path__ + "static/media/noPosterSmall.91e0038f.PNG";